"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var no_1 = require("./no");
/**
 * Convert a `string` to space case.
 */
function spaceCaseIt(str) {
    return no_1.noCaseIt(str)
        .replace(/[\W_]+(.|$)/g, function (matches, match) { return (match ? " " + match : ""); })
        .trim();
}
exports.spaceCaseIt = spaceCaseIt;
